module.exports = __webpack_public_path__ + "img/280-7afc27.png";